import Bowser from 'bowser-ultralight';
import memoizeOne from 'memoize-one';
import { getWindowObject } from '../utils/window-helper';
export const eventBrowserPlugin = memoizeOne(() => {
  var _getWindowObject, _getWindowObject$navi;
  if (!Bowser.getParser) {
    return null;
  }
  const browser = Bowser.getParser(((_getWindowObject = getWindowObject()) === null || _getWindowObject === void 0 ? void 0 : (_getWindowObject$navi = _getWindowObject.navigator) === null || _getWindowObject$navi === void 0 ? void 0 : _getWindowObject$navi.userAgent) || '');
  return {
    'event:browser:name': browser.getBrowserName(),
    'event:browser:version': browser.getBrowserVersion()
  };
});